import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import InnerImageZoom from 'react-inner-image-zoom';
import StandardModal from 'components/consumer/StandardModal';
import PDPShownIn from 'components/consumer/PDP/PDPShownIn';
import useKeyboardControlForIndexedItems from 'hooks/useKeyboardControlForIndexedItems';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import IconArrowRightSimple from 'components/icons/iconArrowRightSimple';
import PDPProductIntroVideo from '../PDPDesktopHeroGallery/PDPProductIntroVideo';
import PDPDesktopFullScreenGallery2Thumbnail from './components/PDPDesktopFullScreenGallery2Thumbnail';
import usePhotoWidth from './usePhotoWidth';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';
const PDPDesktopFullScreenGallery2UI = t0 => {
  const $ = _c(92);
  const {
    isEditOrder: t1,
    enableCrops,
    handleVideoSelected: t2,
    introVideoId: t3,
    isOpen,
    isVideoSelected: t4,
    onClose,
    photos: t5,
    photoSrc: t6,
    productName,
    selectedPhotoIndex,
    setSelectedPhotoIndex,
    videoThumbnailUrl
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const handleVideoSelected = t2 === undefined ? _temp : t2;
  const introVideoId = t3 === undefined ? "" : t3;
  const isVideoSelected = t4 === undefined ? false : t4;
  let t7;
  if ($[0] !== t5) {
    t7 = t5 === undefined ? [] : t5;
    $[0] = t5;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const photos = t7;
  let t8;
  if ($[2] !== t6) {
    t8 = t6 === undefined ? {} : t6;
    $[2] = t6;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const photoSrc = t8;
  const thumbnailWrapperRef = useRef(null);
  const selectedThumbnailRef = useRef(null);
  let t9;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [];
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  const [items, setItems] = useState(t9);
  const [selectedItemIndex, setSelectedItemIndex] = useState(0);
  const [isZoomedIn, setIsZoomedIn] = useState(false);
  let t10;
  let t11;
  if ($[5] !== introVideoId || $[6] !== photos) {
    t10 = () => {
      const photoItems = photos.map(_temp2);
      const videoItem = {
        id: introVideoId,
        itemType: "video"
      };
      const updatedItems = introVideoId && photoItems.length ? [photoItems[0], videoItem, ...photoItems.slice(1)] : photoItems;
      setItems(updatedItems);
    };
    t11 = [photos, introVideoId];
    $[5] = introVideoId;
    $[6] = photos;
    $[7] = t10;
    $[8] = t11;
  } else {
    t10 = $[7];
    t11 = $[8];
  }
  useEffect(t10, t11);
  let t12;
  let t13;
  if ($[9] !== isVideoSelected || $[10] !== items || $[11] !== selectedPhotoIndex) {
    t12 = () => {
      if (isVideoSelected) {
        const videoItemIndex = items.findIndex(_temp3);
        if (videoItemIndex !== -1) {
          setSelectedItemIndex(videoItemIndex);
        }
      } else {
        const photoItemIndex = items.findIndex(item_0 => item_0.itemType === "photo" && item_0.photoIndex === selectedPhotoIndex);
        if (photoItemIndex !== -1) {
          setSelectedItemIndex(photoItemIndex);
        }
      }
    };
    t13 = [selectedPhotoIndex, items, isVideoSelected];
    $[9] = isVideoSelected;
    $[10] = items;
    $[11] = selectedPhotoIndex;
    $[12] = t12;
    $[13] = t13;
  } else {
    t12 = $[12];
    t13 = $[13];
  }
  useEffect(t12, t13);
  let t14;
  if ($[14] !== handleVideoSelected || $[15] !== items || $[16] !== setSelectedPhotoIndex) {
    t14 = index_0 => {
      setIsZoomedIn(false);
      const updatedItem = items[index_0];
      if (updatedItem.itemType === "video") {
        handleVideoSelected(true);
      } else {
        handleVideoSelected(false);
        setSelectedPhotoIndex(updatedItem.photoIndex);
      }
      setTimeout(() => {
        const thumbnailWrapper = thumbnailWrapperRef?.current;
        const selectedThumbnail = selectedThumbnailRef?.current;
        thumbnailWrapper?.scrollTo({
          top: (selectedThumbnail?.offsetTop || 0) - (thumbnailWrapper.clientHeight || 64) / 2,
          behavior: "smooth"
        });
      }, 10);
    };
    $[14] = handleVideoSelected;
    $[15] = items;
    $[16] = setSelectedPhotoIndex;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  const setSelectedItemAndScroll = t14;
  const numberOfItems = photos?.length ?? 0;
  let t15;
  if ($[18] !== isOpen || $[19] !== numberOfItems || $[20] !== selectedItemIndex || $[21] !== setSelectedItemAndScroll) {
    t15 = {
      isEnabled: isOpen,
      numberOfItems,
      selectedIndex: selectedItemIndex,
      setSelectedIndex: setSelectedItemAndScroll
    };
    $[18] = isOpen;
    $[19] = numberOfItems;
    $[20] = selectedItemIndex;
    $[21] = setSelectedItemAndScroll;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  useKeyboardControlForIndexedItems(t15);
  const maxPhotoWidth = usePhotoWidth();
  let t16;
  if ($[23] !== enableCrops || $[24] !== items || $[25] !== selectedItemIndex || $[26] !== setSelectedItemAndScroll || $[27] !== videoThumbnailUrl) {
    t16 = items.map((t17, itemIndex) => {
      const {
        cropData,
        type,
        id,
        itemType,
        src
      } = t17;
      const isItemSelected = itemIndex === selectedItemIndex;
      return <PDPDesktopFullScreenGallery2Thumbnail cropData={cropData} enableCrops={enableCrops} isItemSelected={isItemSelected} itemIndex={itemIndex} itemType={itemType} key={`${id}-${itemType}`} selectedThumbnailRef={selectedThumbnailRef} setSelectedItemAndScroll={setSelectedItemAndScroll} src={src} type={type} videoThumbnailUrl={videoThumbnailUrl} />;
    });
    $[23] = enableCrops;
    $[24] = items;
    $[25] = selectedItemIndex;
    $[26] = setSelectedItemAndScroll;
    $[27] = videoThumbnailUrl;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t16) {
    t17 = <div className="max-h-[calc(90vh_-_4rem)] min-w-[315px] overflow-y-auto w-[325px]" ref={thumbnailWrapperRef}><div className="grid gap-[7px_7px] grid-cols-[142px_142px] mb-px min-w-[300px] w-1/4">{t16}</div></div>;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== maxPhotoWidth) {
    t18 = {
      maxWidth: maxPhotoWidth
    };
    $[31] = maxPhotoWidth;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== productName) {
    t19 = <div className="text-xl font-bold text-gray mb-4 max-w-full text-center w-[2000px]">{productName}</div>;
    $[33] = productName;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== isVideoSelected) {
    t20 = classNames("object-contain object-center select-none p-0 max-w-full relative flex", {
      "w-full": isVideoSelected
    });
    $[35] = isVideoSelected;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== isZoomedIn) {
    t21 = classNames("items-center border-0 bottom-0 flex justify-start opacity-0 absolute top-0 transition-[opacity_.3s] w-[12%] z-[1] mx-0 my-auto focus-visible:opacity-100 focus-visible:outline-offset-[-5px] hover:opacity-100 [background:linear-gradient(90deg,rgba(0,0,0,.35)__.06%,hsla(0,0%,76.9%,0)__99.94%)] left-0  h-full", {
      hidden: isZoomedIn
    });
    $[37] = isZoomedIn;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== numberOfItems || $[40] !== selectedItemIndex || $[41] !== setSelectedItemAndScroll) {
    t22 = () => {
      const previousIndex = selectedItemIndex - 1;
      if (previousIndex < 0) {
        setSelectedItemAndScroll(numberOfItems - 1);
      } else {
        setSelectedItemAndScroll(previousIndex);
      }
    };
    $[39] = numberOfItems;
    $[40] = selectedItemIndex;
    $[41] = setSelectedItemAndScroll;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  let t24;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <IconArrowRightSimple width={22} height={40} className="ml-2.5 -rotate-180" color="white" />;
    t24 = <VisuallyHidden>Previous image</VisuallyHidden>;
    $[43] = t23;
    $[44] = t24;
  } else {
    t23 = $[43];
    t24 = $[44];
  }
  let t25;
  if ($[45] !== t21 || $[46] !== t22) {
    t25 = <button type="button" className={t21} onClick={t22}>{t23}{t24}</button>;
    $[45] = t21;
    $[46] = t22;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== isVideoSelected || $[49] !== photoSrc) {
    t26 = !isVideoSelected && photoSrc?.zoomSrc ? <InnerImageZoom height={600} src={photoSrc.src} zoomSrc={photoSrc.zoomSrc} zoomPreload={true} hasSpacer={true} hideCloseButton={true} hideHint={true} afterZoomIn={() => {
      setIsZoomedIn(true);
    }} afterZoomOut={() => {
      setIsZoomedIn(false);
    }} /> : null;
    $[48] = isVideoSelected;
    $[49] = photoSrc;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== introVideoId || $[52] !== isVideoSelected) {
    t27 = isVideoSelected && introVideoId ? <PDPProductIntroVideo variant="PDPDesktopFullScreenGallery2" videoId={introVideoId} /> : null;
    $[51] = introVideoId;
    $[52] = isVideoSelected;
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  let t28;
  if ($[54] !== isZoomedIn) {
    t28 = classNames("items-center border-0 bottom-0 flex opacity-0 absolute top-0 transition-[opacity_.3s] w-[12%] z-[1] mx-0 my-auto focus-visible:opacity-100 focus-visible:outline-offset-[-5px] hover:opacity-100 [background:linear-gradient(270deg,rgba(0,0,0,.35)__.06%,hsla(0,0%,76.9%,0)__99.94%)] justify-end right-0 h-full", {
      hidden: isZoomedIn
    });
    $[54] = isZoomedIn;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  let t29;
  if ($[56] !== numberOfItems || $[57] !== selectedItemIndex || $[58] !== setSelectedItemAndScroll) {
    t29 = () => {
      const nextIndex = selectedItemIndex + 1;
      if (nextIndex >= numberOfItems) {
        setSelectedItemAndScroll(0);
      } else {
        setSelectedItemAndScroll(nextIndex);
      }
    };
    $[56] = numberOfItems;
    $[57] = selectedItemIndex;
    $[58] = setSelectedItemAndScroll;
    $[59] = t29;
  } else {
    t29 = $[59];
  }
  let t30;
  let t31;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <IconArrowRightSimple width={22} height={40} className="mr-2.5" color="white" />;
    t31 = <VisuallyHidden>Next image</VisuallyHidden>;
    $[60] = t30;
    $[61] = t31;
  } else {
    t30 = $[60];
    t31 = $[61];
  }
  let t32;
  if ($[62] !== t28 || $[63] !== t29) {
    t32 = <button type="button" className={t28} onClick={t29}>{t30}{t31}</button>;
    $[62] = t28;
    $[63] = t29;
    $[64] = t32;
  } else {
    t32 = $[64];
  }
  let t33;
  if ($[65] !== t20 || $[66] !== t25 || $[67] !== t26 || $[68] !== t27 || $[69] !== t32) {
    t33 = <div className={t20}>{t25}{t26}{t27}{t32}</div>;
    $[65] = t20;
    $[66] = t25;
    $[67] = t26;
    $[68] = t27;
    $[69] = t32;
    $[70] = t33;
  } else {
    t33 = $[70];
  }
  let t34;
  if ($[71] !== isEditOrder || $[72] !== isVideoSelected || $[73] !== onClose || $[74] !== photos || $[75] !== productName || $[76] !== selectedPhotoIndex) {
    t34 = !isVideoSelected && <div className="flex-[1_1] flex items-center justify-end"><div className="PDPDesktopFullScreenGallery2__MainPhoto-shownin"><PDPShownIn fullWidth={true} isEditOrder={isEditOrder} optionId={photos?.[selectedPhotoIndex]?.optionId} valueId={photos?.[selectedPhotoIndex]?.valueId} upholsteryName={photos?.[selectedPhotoIndex]?.upholsteryName} onSelection={() => {
          onClose(true);
        }} layout="greyBG" showInactiveUpholstery={true} productName={productName} /></div></div>;
    $[71] = isEditOrder;
    $[72] = isVideoSelected;
    $[73] = onClose;
    $[74] = photos;
    $[75] = productName;
    $[76] = selectedPhotoIndex;
    $[77] = t34;
  } else {
    t34 = $[77];
  }
  let t35;
  if ($[78] !== t34) {
    t35 = <div className="flex flex-row mt-4 w-full">{t34}</div>;
    $[78] = t34;
    $[79] = t35;
  } else {
    t35 = $[79];
  }
  let t36;
  if ($[80] !== t18 || $[81] !== t19 || $[82] !== t33 || $[83] !== t35) {
    t36 = <div className="items-center flex flex-col ml-6"><div className="items-center bg-transparent border-0 flex flex-col flex-1 justify-between max-h-[calc(90vh_-_4rem)] overflow-y-hidden" style={t18}>{t19}{t33}{t35}</div></div>;
    $[80] = t18;
    $[81] = t19;
    $[82] = t33;
    $[83] = t35;
    $[84] = t36;
  } else {
    t36 = $[84];
  }
  let t37;
  if ($[85] !== t17 || $[86] !== t36) {
    t37 = <div className="flex flex-row justify-center w-full">{t17}{t36}</div>;
    $[85] = t17;
    $[86] = t36;
    $[87] = t37;
  } else {
    t37 = $[87];
  }
  let t38;
  if ($[88] !== isOpen || $[89] !== onClose || $[90] !== t37) {
    t38 = <div className="w-full"><StandardModal isOpen={isOpen} onClose={onClose} theme="light" size="xl">{t37}</StandardModal></div>;
    $[88] = isOpen;
    $[89] = onClose;
    $[90] = t37;
    $[91] = t38;
  } else {
    t38 = $[91];
  }
  return t38;
};
PDPDesktopFullScreenGallery2UI.propTypes = {
  enableCrops: PropTypes.bool,
  handleVideoSelected: PropTypes.func,
  introVideoId: PropTypes.string,
  isEditOrder: PropTypes.bool,
  isOpen: PropTypes.bool,
  isVideoSelected: PropTypes.bool,
  onClose: PropTypes.func,
  photos: PropTypes.arrayOf(PropTypes.shape({
    cropData: PropTypes.object,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    optionId: PropTypes.number,
    src: PropTypes.string,
    type: PropTypes.oneOf(['buildyourown', 'configuration', 'dimensional', 'studio']),
    upholsteryName: PropTypes.string,
    valueId: PropTypes.number
  })),
  photoSrc: PropTypes.shape({
    src: PropTypes.string,
    zoomSrc: PropTypes.string
  }),
  productName: PropTypes.string,
  selectedPhotoIndex: PropTypes.number,
  setSelectedPhotoIndex: PropTypes.func,
  videoThumbnailUrl: PropTypes.string
};
export default PDPDesktopFullScreenGallery2UI;
function _temp() {}
function _temp2(photo, index) {
  return {
    cropData: photo.cropData,
    type: photo.type,
    id: photo.id,
    itemType: "photo",
    optionId: photo.optionId,
    photoIndex: index,
    src: photo.src,
    upholsteryName: photo.upholsteryName,
    valueId: photo.valueId
  };
}
function _temp3(item) {
  return item.itemType === "video";
}